var map = {
	"./batiment-bienvenue.png": 53357,
	"./batiment-cafe_de_la_place.png": 51122,
	"./batiment-controle.png": 97469,
	"./batiment-fin.png": 10630,
	"./batiment-inventaire.png": 10960,
	"./batiment-livraison.png": 73312,
	"./batiment-maintenance.png": 10912,
	"./batiment-objets_trouves.png": 54275,
	"./batiment-place_du_marche.png": 49851,
	"./batiment-plan_de_la_ville.png": 58921,
	"./batiment-prevention.png": 15721,
	"./batiment-securite.png": 42103,
	"./batiment-tri.png": 92782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14956;